import { render, staticRenderFns } from "./ova.vue?vue&type=template&id=64d61b6a&scoped=true&"
import script from "./ova.vue?vue&type=script&lang=js&"
export * from "./ova.vue?vue&type=script&lang=js&"
import style0 from "./ova.vue?vue&type=style&index=0&id=64d61b6a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d61b6a",
  null
  
)

export default component.exports